import '@google-pay/button-element';
export default{
    data(){
        return{
            googlePayAccountId:0,
            googlePayAccountName:null,

            googlePayProp:{
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [
                    {
                    type: 'CARD',
                    parameters: {
                        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                        allowedCardNetworks: ['MASTERCARD', 'VISA'],
                    },
                    tokenizationSpecification: {
                        type: 'PAYMENT_GATEWAY',
                        parameters: {
                        gateway: 'cayan',
                        gatewayMerchantId: 'Z76YQWHZUTH4KU2B',
                        },
                    },
                    },
                ],
                merchantInfo: {
                    merchantId: '12345678901234567890',
                    merchantName: 'Demo Merchant',
                },
                transactionInfo: {
                    totalPriceStatus: 'FINAL',
                    totalPriceLabel: 'Total',
                    totalPrice: '5.00',
                    currencyCode: 'USD',
                    countryCode: 'US',
                },
            }

        }
    },
    computed:{
        showGooglePay(){
            if(window.SHOW_GOOGLE_PAY==undefined){return false}
            else{return window.SHOW_GOOGLE_PAY}
        },
    },
    methods:{
         onLoadPaymentData(event) {
            console.log('load payment data', event.detail);

           this.handleGooglePayment(event.detail.paymentMethodData)
  
        },
        onError(event) {
            console.error('error', event.error);
        },
        async handleGooglePayment(paymentMethodData){
            console.log('in handlegooglepayment ' + paymentMethodData)
             //move this
            var FundRequest={
                ID:this.googlePayAccountId,
                Name:this.googlePayAccountName,
                TokenID:0,
                Amount:5.00,
                FeeAmount:0,
                TaxAmount:0
            }
            let req = {
                initialAccountFundList:[FundRequest],
                googleToken:paymentMethodData.tokenizationData.token
            }
            var response =  await this.callAPI(req,'paymenttoaccount_google')

            if(response.Successful){
            
                this.$emit('refresh')
                this.responseMessage="Submit Funds Successful"
           
            }else{
                this.responseMessage = response.Message
         
            }

        },
    }
}